/**
 * Blog pagination
 */
	function getMimeType(image) {
		if (image?.endsWith('.webp')) return 'image/webp'
		if (image?.endsWith('.jpg')) return 'image/jpeg'
		if (image?.endsWith('.jpeg')) return 'image/jpeg'
		if (image?.endsWith('.png')) return 'image/png'
		if (image?.endsWith('.gif')) return 'image/gif'
		if (image?.endsWith('.svg')) return 'image/svg+xml'
		if (image?.endsWith('.ico')) return 'image/x-icon'
		if (image?.endsWith('.bmp')) return 'image/bmp'
		if (image?.endsWith('.tiff')) return 'image/tiff'
		return 'image/jpeg'
	}

	function blogPostTemplate(item, postUrl, storagePath) {
		if (item.type === 'ebook') {
			return `
				<div class="col-sm-6 col-lg-4">
					<a href="${item.ebook}" class="blog--i" target="_blank" rel="noopener noreferrer">
						<picture class="blog--i_img mr--i mr--i_blog mr--i_3by2-mobile is--rounded">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}.webp" type="image/webp">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" type="${getMimeType(item?.image_thumbnail)}">
							<img src="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" class="mr--i_full" alt="" loading="lazy">
						</picture>

						<div class="blog--i_content">
							<h3 class="blog--i_title h4 my-0">
								${item.name}
							</h3>

							<span class="blog--i_button">
								<span>${window.Translations?.baixeAgora}</span>
								<svg class="ic--i ic--i_arrow-h"><use xlink:href="#ic-arrow-h"></use></svg>
							</span>

							<span class="blog--i_legend subtitle cl--cream">
								${item.category_name ? item.category_name : window.Translations?.ebook}
							</span>
						</div>
					</a>
				</div>
			`
		}

		if (item.type === 'post') {
			return `
				<div class="col-sm-6 col-lg-4">
					<a href="${postUrl.replace('[SLUG_REPLACE]', item.slug)}" class="blog--i">
						<picture class="blog--i_img mr--i mr--i_blog mr--i_3by2-mobile is--rounded">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}.webp" type="image/webp">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" type="${getMimeType(item?.image_thumbnail)}">
							<img src="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" class="mr--i_full" alt="" loading="lazy">
						</picture>

						<div class="blog--i_content">
							<h3 class="blog--i_title h4 my-0">
								${item.name}
							</h3>

							<span class="blog--i_button">
								<span>${window.Translations?.saibaMais}</span>
								<svg class="ic--i ic--i_arrow-h"><use xlink:href="#ic-arrow-h"></use></svg>
							</span>

							<span class="blog--i_legend subtitle cl--cream">
								${item.category_name ? item.category_name : ''}
							</span>
						</div>
					</a>
				</div>
			`
		}

		if (item.type === 'video') {
			return `
				<div class="col-sm-6 col-lg-4">
					<a href="${item.video}" class="blog--i" data-fancybox data-caption="${item.name}">
						<picture class="blog--i_img mr--i mr--i_blog mr--i_3by2-mobile is--rounded">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}.webp" type="image/webp">
							<source srcset="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" type="${getMimeType(item?.image_thumbnail)}">
							<img src="${storagePath.replace('[ID_REPLACE]', item.id).replace('[IMAGE_REPLACE]', item?.image_thumbnail)}" class="mr--i_full" alt="" loading="lazy">
						</picture>

						<div class="blog--i_content">
							<h3 class="blog--i_title h4 my-0">
								${item.name}
							</h3>

							<span class="blog--i_button">
								<span>${window.Translations?.assistaAgora}</span>
								<svg class="ic--i ic--i_arrow-h"><use xlink:href="#ic-arrow-h"></use></svg>
							</span>

							<span class="blog--i_legend subtitle cl--cream">
								${item.category_name ? item.category_name : window.Translations?.videoAula}
							</span>
						</div>
					</a>
				</div>
			`
		}
	}


	window.euroromaNextPage = 2

	const siteLoadPosts = document.querySelector('[site-load-posts]')
	const sitePostsList = document.querySelector('[site-posts-list]')

	if (siteLoadPosts && sitePostsList) {
		siteLoadPosts.addEventListener('click', event => {
			event.preventDefault()
			siteLoadPosts.classList.add('is--loading')
			const url = siteLoadPosts.dataset.url + '?page=' + window.euroromaNextPage
			const postUrl = siteLoadPosts.dataset.postUrl
			const storagePath = siteLoadPosts.dataset.storagePath

			axios.get(url).then(response => {
				const resp = response.data

				window.euroromaNextPage++

				if (resp.current_page === resp.last_page) siteLoadPosts.parentElement.remove()

				resp.data.forEach(item => {
					sitePostsList.insertAdjacentHTML('beforeend', blogPostTemplate(item, postUrl, storagePath))
				})
			}).catch(error => {
				console.log(error)
				alert('Erro ao carregar mais posts.')
			}).finally(() => {
				siteLoadPosts.classList.remove('is--loading')
			})
		})
	}
